<script setup lang="ts">
  import type { Invoice } from '@stuut/api/models';
  import { humanize } from '@stuut/common/src/utils';
  import type { BadgeVariants } from '@ui/components/badge';
  import StatusBadge from '@ui/components/common/StatusBadge.vue';
  import { cn } from '@ui/utils/utils';

  import { useInvoiceDisplay } from '@/composables/useInvoiceDisplay';

  const props = withDefaults(
    defineProps<{
      badgeSize?: BadgeVariants['size'];
      invoice: Invoice;
      size?: 'sm' | 'lg';
      stampPosition?: string;
    }>(),
    {
      badgeSize: 'xs',
      size: 'sm',
      stampPosition: 'right-0 -top-1',
    },
  );

  const { showStamp, stampColorClass, displayStatus } = useInvoiceDisplay(() => props.invoice);
</script>

<template>
  <div v-if="showStamp" class="relative h-full min-w-1">
    &nbsp;

    <div
      class="pointer-events-none absolute z-1 origin-center select-none rotate-4 opacity-80 text-center"
      :class="stampPosition"
    >
      <strong
        :class="
          cn(
            'font-mono tracking-[0.3em] uppercase',
            size === 'lg' ? 'pl-4 pr-2 py-1 text-3xl' : 'px-2.5 py-1.5 text-base',
            stampColorClass,
          )
        "
      >
        {{ humanize(invoice.status) }}
      </strong>
    </div>
  </div>

  <div v-else class="flex shrink-0 items-center">
    <StatusBadge :value="displayStatus" :size="badgeSize" class="uppercase tracking-[0.25em]" />
  </div>
</template>
